import { Component, Output, EventEmitter, ElementRef, AfterViewInit, OnChanges, input, computed } from '@angular/core';
import { AnalyticsCellValue } from '../analytics.model';

export interface DataTableCellset {
    header?: string;
    section: AnalyticsCellValue[][];
}

export interface DataTableSection {
    title: string;
    subTitles: string[];
    table: DataTableCellset[];
}

@Component({
    selector: 'key-analytics-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss'],
    standalone: false
})
export class AnalyticsDataTableComponent implements AfterViewInit, OnChanges {
    headerWidth: string;

    cellset = input<DataTableSection[]>();
    selected = input<string>();
    @Output() onHeaderClick = new EventEmitter<AnalyticsCellValue>();

    constructor(
        private el: ElementRef
    ) { }

    updatedCellset = computed(() => {
        return this.cellset().map(dataTableSection => ({
            ...dataTableSection,
            table: dataTableSection.table.map(cellset => ({
                ...cellset,
                section: cellset.section.map(row => row.map(cell => ({ ...cell, value: String(cell.value) })))
            }))
        }));
    });


    doOnHeaderClick(header: AnalyticsCellValue) {
        if (header.properties.color) {
            this.onHeaderClick.emit(header);
        }
    }

    ngOnChanges() {
        setTimeout(() => {
            this.updateHeaderWidth();
        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.updateHeaderWidth();
        });
    }

    // table headings doesn't fill overflow sections... this forces it to be the same as the actual table
    updateHeaderWidth() {
        const table = this.el.nativeElement.querySelector('.data-table__table');
        this.headerWidth = table && table.clientWidth + 'px';
    }
}
